module.exports = __webpack_public_path__ + "img/DefaultPhotoBoy.c9022827.png";